import { format, isDate } from 'date-fns'
import countEvents from './countEvents'
import handleResponse from './request/handleResponse'
import { IEvent } from '.'

const buildUrl = (
  calendarId: number,
  pageSize: number,
  page: number,
  modifyDate?: Date,
  startDate?: Date,
  finishDate?: Date,
  includeDeleted = false,
): string => {
  const d: number = isDate(modifyDate)
    ? Math.floor(modifyDate.getTime() / 1000)
    : 0

  return d > 0
    ? `/api/v2/reservation/list/id_calendar/${calendarId}/modify_date/${d}/page_size/${pageSize}/page/${page}/include_deleted/1`
    : `/api/v2/reservation/list/id_calendar/${calendarId}/page_size/${pageSize}/page/${page}/include_deleted/${Number(
        includeDeleted,
      )}${
        startDate && finishDate
          ? `/date_from/${format(startDate, 'YYYY-MM-DD')}/date_to/${format(
              finishDate,
              'YYYY-MM-DD',
            )}`
          : ''
      }`
}

export function fetchEventsPaginated(
  fetch: GlobalFetch,
  startDate,
  finishDate,
  includeDeleted,
) {
  return async function(
    calendarId: number,
    pageSize = 5000,
    pageNumber = 1,
    modifyDate?: Date,
  ): Promise<IEvent[]> {
    const response = await fetch.fetch(
      buildUrl(
        calendarId,
        pageSize,
        pageNumber,
        modifyDate,
        startDate,
        finishDate,
        includeDeleted,
      ),
    )

    return await handleResponse(response)
  }
}

export default function(fetch: GlobalFetch) {
  return async function(
    calendarId: number,
    modifyDate?: Date,
    startDate?: Date,
    finishDate?: Date,
    includeDeleted = false,
  ) {
    const fetchEvents = fetchEventsPaginated(
      fetch,
      startDate,
      finishDate,
      includeDeleted,
    )
    const fetchCounts = countEvents(fetch, startDate, finishDate)

    if (isDate(modifyDate) && modifyDate.getTime() > 0) {
      return fetchEvents(calendarId, 5000, 1, modifyDate)
    }

    const { count } = await fetchCounts(calendarId)
    const requestNumber = Math.ceil(count / 5000)

    const requests = Array.from(new Array(requestNumber))
      .map((_, index) => index)
      .map(index => fetchEvents(calendarId, 5000, index + 1))

    const responses = await Promise.all(requests)

    return responses.reduce((a, b) => [...a, ...b], [])
  }
}
